// Active-brand loader for the admin dashboard.
//
// The brand is selected at build time via VITE_BRAND (defaults to 'edh', which
// reproduces the current EDH look exactly). Color tokens are written to CSS
// variables on :root; the Tailwind theme (tailwind.config.js) references those
// variables, so remapping the accent reskins every amber-*/edh-* utility at once.
//
// Brand JSON is the shared cross-surface source of truth in /brands.
import edh from '@brands/edh.json';
import pokeratlas from '@brands/pokeratlas.json';
import pokeratlasFavicon from '@brands/pokeratlas/assets/pokeratlas-icon.png';

const BRANDS = { edh, pokeratlas };
// Per-brand favicon overrides (EDH keeps the static /favicon.svg in index.html).
const FAVICONS = { pokeratlas: pokeratlasFavicon };

const BRAND_ID = (import.meta.env.VITE_BRAND || 'edh').toLowerCase();

export const brand = BRANDS[BRAND_ID] || edh;

// Map brand color tokens -> CSS variables consumed by Tailwind.
// Keys intentionally keep the existing --brand-gold* names so the EDH default
// is byte-identical; for non-EDH brands these simply resolve to the new accent.
export function applyBrand(b = brand) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const c = (b && b.colors) || {};
  if (c.primary) root.style.setProperty('--brand-gold', c.primary);
  if (c.primaryLight) root.style.setProperty('--brand-gold-light', c.primaryLight);
  if (c.primaryDark) root.style.setProperty('--brand-gold-dark', c.primaryDark);
  const title = b && b.naming && b.naming.adminTitle;
  if (title) document.title = title;
  // Swap the favicon for non-EDH brands.
  const fav = FAVICONS[BRAND_ID];
  if (fav) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/png';
    link.href = fav;
  }
}

export default brand;
